// extracted by mini-css-extract-plugin
module.exports = {"root":"root__3WI0j"};